export default __webpack_public_path__ + "assets/images/6f80635b010d77cecd2581ab96355cfc.svg";